import { render, staticRenderFns } from "./OrderStatusTabs.vue?vue&type=template&id=a8075d64&"
import script from "./OrderStatusTabs.vue?vue&type=script&lang=ts&"
export * from "./OrderStatusTabs.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatusTabs.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports